import React from 'react'
import {useSelector} from 'react-redux'
import {Box} from '@vio/atlas/helpers/Box'
import {Popover, PopoverPlacement} from '@vio/atlas/Popover'
import {AllOffersDropdown} from 'components/Accommodation/Offers/AllOffersDropdown'
import {getIsRtlLanguage} from 'modules/meta/selectors'

import {Hotel} from '@findhotel/sapi'

interface Props {
  isOpen: boolean
  anchorRef: React.RefObject<HTMLElement>
  onOutsideClick: (e: MouseEvent) => void
  hotelId?: Hotel['objectID']
}

// Added as part of df9r3t7e-desktop-more-deals-dropdown
export const MoreDealsDropdown = ({
  isOpen,
  anchorRef,
  onOutsideClick,
  hotelId
}: Props) => {
  const isRTL = useSelector(getIsRtlLanguage)
  const containerWidth = anchorRef?.current?.clientWidth || 319

  return (
    <Popover
      isOpen={isOpen}
      anchorRef={anchorRef}
      verticalOffset={45}
      horizontalOffset={0}
      onOutsideClick={e => onOutsideClick(e)}
      placement={isRTL ? PopoverPlacement.Right : PopoverPlacement.Left}
    >
      <Box width={`${containerWidth}px`}>
        <AllOffersDropdown hotelId={hotelId} />
      </Box>
    </Popover>
  )
}
